module.exports = __webpack_public_path__ + "img/mb-imagery.367a4353.png";